// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__sw2Gt","bigColWidth":"Table_bigColWidth__19pjb","biggerColWidth":"Table_biggerColWidth__IK_6y","row":"Table_row__3pngE","col":"Table_col__189Mw"};